import type { ApiResponse, ContactFormData, GalleryImage, InquiryFormData } from '@/types'

const BASE_URL = import.meta.env.VITE_API_BASE_URL as string

async function request<T>(path: string, options?: RequestInit): Promise<ApiResponse<T>> {
  const res = await fetch(`${BASE_URL}${path}`, {
    headers: { 'Content-Type': 'application/json' },
    ...options,
  })

  const data = (await res.json()) as ApiResponse<T>
  return data
}

export async function submitInquiry(
  payload: InquiryFormData
): Promise<ApiResponse<{ id: string }>> {
  return request('/api/inquire', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export async function submitContact(
  payload: ContactFormData
): Promise<ApiResponse<{ id: string }>> {
  return request('/api/contact', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export async function fetchGallery(
  category?: string
): Promise<ApiResponse<GalleryImage[]>> {
  const params = category ? `?category=${category}` : ''
  return request(`/api/gallery${params}`)
}

export async function healthCheck(): Promise<ApiResponse<{ status: string }>> {
  return request('/api/health')
}
